import React, { Fragment, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';

import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';

import { Chip, JwlTable, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { GQLAddressHelper } from '../../../../operations/helpers/GQLAddressHelper';
import { PlatformNavigation } from '../../navigation/PlatformNavigation';
import { GQLPartyHelper } from '../../../../operations/helpers/GQLPartyHelper';
import { getDefaultRouteByPartyType } from '../../../../AppRoutes';
import { AuthContext } from '../../../../core/AuthContext';

interface IProps {
  party: GQLParty;
}

const PartyList: React.FC<IProps> = ({ party }: IProps) => {
  const history = useHistory();
  const [filteredParties, setFilteredParties] = useState('');
  const { t: translate } = useTranslation();
  const authenticationContext = useContext(AuthContext);

  const { data: partiesData, loading: partiesLoading } = GQLOperationBuilder.party.getPartiesByPlatform({});

  const [impersonate, {}] = GQLOperationBuilder.security.impersonate();

  if (partiesLoading) return <LoadingSpinner />;

  const parties = GQLOperationBuilder.party.partyArrayFromResponse(partiesData);

  const handleFilterChange = (event: any) => setFilteredParties(event.target.value);

  const getPartyRows = () => {
    return parties
      .filter(party => {
        return (
          party.name.toLowerCase().includes(filteredParties.toLowerCase().trim()) ||
          party.email.toLowerCase().includes(filteredParties.toLowerCase().trim()) ||
          party.type.toLowerCase().includes(filteredParties.toLowerCase().trim())
        );
      })
      .map(party => {
        return {
          id: party.id,
          cells: [
            party.id,
            GQLPartyHelper.isSystemParty(party.id) ? (
              <Chip size="small" mr={1} mb={1} label={`${party.type} - SYSTEM`} $active={false} />
            ) : (
              <Fragment>{party.type}</Fragment>
            ),
            party.name,
            party.email,
            GQLAddressHelper.addressToString(party.address),

            <Button
              variant={'contained'}
              color={'primary'}
              onClick={() =>
                impersonate({
                  variables: { targetPartyId: party.id }
                }).then(response => {
                  const authentication = GQLOperationBuilder.security.authenticationFromResponse(
                    response.data
                  );
                  authenticationContext.setAuthentication(authentication);
                  history.push(getDefaultRouteByPartyType(authentication.securityContext.partyType));
                })
              }
              disabled={GQLPartyHelper.isSystemParty(party.id)}
            >
              Impersonate
            </Button>
          ]
        };
      });
  };

  const navigateToPartyDetails = (partyId: string) => {
    history.push(
      PlatformNavigation.partyDetails.pathFromParams({
        partyId: partyId
      })
    );
  };

  return (
    <Fragment>
      <JwlTable
        title="Platform parties list"
        description={`The list of all parties defined in the platform.`}
        columns={['ID', 'Type', 'Name', 'Contact e-mail', 'Address', 'Action']}
        rows={getPartyRows()}
        onFilterChange={handleFilterChange}
        onTableRowClick={navigateToPartyDetails}
      />
    </Fragment>
  );
};

export default PartyList;
